module.exports = __webpack_public_path__ + "img/DuckDuckGo_2023.091581fc.svg";